<template>
  <div class="white-container">
    <div v-for="(activity, index) in activities" :key="index" class="d-flex vertical-center space-between mt-15px mobile-layout">
      <div class="activity-img" >
        <img :src="activity.icon" />
      </div>
      <div class="d-flex vertical-center pr-20px content-box text-activity w-100">
        <div>
          <h2>{{ activity.title }}</h2>
          <p class="paragraph">{{ activity.description }}</p>
        </div>
      </div>
      <div class="position-relative">
        <input class="calculators-input-round " v-model="results[activity['title']]"
          @input="$emit('update:modelValue', results); checkError()" />
        <div class="percent-activity">%</div>
      </div>
    </div>
    <div class="d-flex vertical-center d-flex-end  mt-15px">
      <label class="label-total-input">Total</label>
      <div class="position-relative">
        <div class="error">{{ error }}</div><input class="total-input w-100" type="number" :value="totalPercent"
          readonly />
        <div class="total-input-percent">%</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      results: {

      },
      activities: [
        {
          title: "Activités peu émettrices",
          icon: require("@/assets/images/musee.png"),
          description:
            "Cinéma, plein air, musée, site historique, restaurant, centre d’amusement, etc.",
          factor: 1
        },
        {
          title: "Activités moyennement émettrices",
          icon: require("@/assets/images/concert.png"),
          description:
            "Centre aquatique, ski alpin, spa, tour guidé en autobus, festival et spectacle, etc.",
          factor: 3
        },
        {
          title: "Activités fortement émettrices",
          icon: require("@/assets/images/karting.png"),
          description: "VTT, motoneige, karting, fête foraine, etc.",
          factor: 19
        },
        {
          title: "Activités très fortement émettrices",
          icon: require("@/assets/images/parachute.png"),
          description: "Hélicoptère, avion, bateau, parachutisme, etc.",
          factor: 49
        },
      ],
      error: null
    };
  },
  props: {
    modelValue: Object
  },
  methods: {
    checkError() {
      if (parseFloat(this.totalPercent) !== 100) {
        this.error = 'Le total de pourcentage doit être 100%'
        this.$emit('onError', true)
      }
      else {
        this.error = null
        this.$emit('onError', false)
      }
    }
  },
  computed: {
    totalPercent() {
      let total = 0
      Object.keys(this.results).forEach(element => {
        if(this.results[element]){
          total += parseFloat(this.results[element])
        }
       
      })
      return total
    }
  },
  watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  }
};
</script>
<style scoped>
h2 {
  color: var(--text-color);
  font-family: var(--font);
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.1em;
  margin-bottom: 0;
  /* 103.75% */
}

.activity-img {
  max-width: 191.5px;
  max-height: 191.503px;
  padding-right: 10px;

}
.activity-img >img{
  width:90%;
}
.text-activity .paragraph{
  margin-top: 0;
}
.percent-activity {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 40px;
  color: #BAB1B1;
  text-align: center;
  font-family: var(--font);
  font-size: 42px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media screen and (max-width: 1250px) {
  .activity-img {
    max-width: 100px;
    max-height: 100px;
    padding-right: 10px;
    width:90%;
  }
  .position-relative{
    width:100%;
   
  }
  .calculators-input-round {
    width:100%;
    box-sizing: border-box;
  }
  .text-activity{
    width:calc(100% - 150px);
  }
  .text-activity h2{
    font-size: 30px;
  }
  .mobile-w-100 {
    width: 100%;
  }
  .mobile-layout{
    justify-content:flex-start;
  }
  .d-flex {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 1500px) {
  .calculators-input-round{
    padding: 15px 25px;
  }
}

@media screen and (max-width: 992px) {
    .percent-activity{
        font-size: 25px;
    }
    .calculators-input-round{
        font-size: 20px;
        padding:15px 20px;
    }

}

@media screen and (max-width: 750px) {
  .activity-img{
    width:80px;
  }
  .text-activity h2{
    font-size: 20px;
    margin-bottom: 0;
    line-height: 1.1em;
  }
}
@media screen and (max-width: 600px) {
  .calculators-input-round{
    width:100%;
    font-size: 20px;
    padding-left: 5px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .percent-activity{
    right:25px;
    font-size: 25px;
  }
  .activity-img{
    width:60px;
  }
  .text-activity{
    width:calc(100% - 90px);
  }
}
</style>
